/* global Localize */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import {
    Button,
    Form,
    Segment,
    Header,
    Container,
    Checkbox,
    Icon,
    Dropdown,
    Modal,
    Grid,
    Divider,
    List,
} from 'semantic-ui-react'
import Input from 'components/InputForm'

import Imgclientes from '../../images/clientes.png'
import loginBackground from '../../images/loginBackground.png'
import { login, setLanguage } from 'store/actions/app'
import LogoImg from '../../images/rufLogoWhite.png'
import appstoreImg from '../../images/appstore_img.png'
import playstoreImg from '../../images/playstore_img.png'
import backgroundLoginMovil from '../../images/backgroundMovil.png'
import { validateLogoToken } from 'store/actions/sys_companys'
import { useWindowDimensions } from 'semantic-table/dist/components/WindowSize'
import translations from '../../utils/translations'

const LoginRoute = (props) => {
    const [openModal, setOpenModal] = useState(false)
    const [openModalPassword, setOpenModalPassword] = useState(false)
    const [logoToken, setLogoToken] = useState(null)
    const { width } = useWindowDimensions()
    const [logoUrl, setLogoUrl] = useState(null)
    const logoImageUrl = logoToken ? logoUrl : LogoImg

    const [username, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

    useEffect(() => {
        const fetchData = async () => {
            const urlParams = new URLSearchParams(window.location.search)
            const token = urlParams.get('e')

            if (token) {
                setLogoToken(token)
                try {
                    const logoUrl = await props.validateLogoToken(token)
                    console.log('Logo URL in LoginRoute:', logoUrl)
                    setLogoUrl(logoUrl)
                } catch (error) {
                    console.error('Error validating logo token:', error.message)
                    // You can handle the error here according to your needs
                }
            }
        }

        if (typeof Localize !== 'undefined' && Localize.showWidget) {
            Localize.showWidget()
        }

        fetchData()
    }, [props])

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768)
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault()
        props.login({ username, password })
    }

    const containerStyle = {
        minHeight: '100vh',
        // width: '100vw',/Cambio para que auste bien el ancho
        display: 'flex',
        // backdropFilter: 'blur(8px)',
        flexDirection: isMobile ? 'column-reverse' : 'row',
        background: isMobile
            ? `linear-gradient(url(${backgroundLoginMovil})`
            : `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),url(${loginBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
    }

    const buttonStyle = {
        // width: '6.5rem',
        // height: '4.5rem',
        background: 'rgba(77, 73, 73, 0.3)',
        // backdropFilter: 'blur(2px)',
        width: isMobile ? '65px' : '80px',
        height: isMobile ? '65px' : '60px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '0.5rem',
        color: 'white',
        fontSize: isMobile ? '0.8rem' : '1rem',
    }

    return (
        <div style={containerStyle}>
            {/* Left Section */}
            <Container
                style={{
                    flex: isMobile ? 'none' : 1.2,
                    display: 'flex',
                    alignItems: 'center',
                    padding: isMobile ? '2rem 1rem' : '1rem',
                    minHeight: isMobile ? 'auto' : '100vh',
                }}
            >
                <div style={{ color: 'white', width: '100%' }}>
                    <Header
                        as="h1"
                        style={{
                            fontSize: isMobile ? '2.5rem' : '3.5rem',
                            color: 'white',
                            marginBottom: '1rem',
                            display: isMobile ? 'none' : 'flex',
                            justifyContent: 'center',
                            textAlign: isMobile ? 'center' : 'center',
                            padding: isMobile ? '0rem' : '0rem',
                        }}
                    >
                        {/* <img src={banner} alt="Logo"
              style={{
                maxWidth: '1200px',
                maxHeight: '500px',
                width: '100%',
                height: '100%',
                borderRadius: "5%",
                objectFit: 'contain',
                margin: 0,
              }} /> */}
                        <p
                            style={{
                                // fontSize: isMobile ? '2.5rem' : '4rem',
                                marginBottom: '1rem',
                                maxWidth: '800px',
                                textAlign: isMobile ? 'center' : 'left',
                                marginLeft: isMobile ? '0rem' : '5rem',
                                // textShadow: isMobile ? '1px 1px 3px #ffffff' : '1px 1px 4px #ffffff',
                            }}
                        >
                            <span
                                style={{
                                    fontSize: isMobile ? '2.5rem' : '4rem',
                                    display: 'block',
                                    marginBottom: '-2.5rem', // Reduce el espacio entre líneas
                                }}
                            >
                                {props.currentTranslations?.title}
                            </span>
                            <br />
                            <span
                                style={{
                                    fontSize: isMobile ? '2rem' : '2.35rem',
                                    fontWeight: 'lighter',
                                    display: 'block',
                                    marginTop: '-3rem', // Reduce el espacio después del br
                                }}
                            >
                                {props.currentTranslations?.welcomeText}
                            </span>
                        </p>
                    </Header>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: isMobile
                                ? 'space-between'
                                : 'space-evenly', //space-evenly
                            marginLeft: isMobile ? '0rem' : '5rem',
                        }}
                    >
                        <Button
                            style={buttonStyle}
                            icon
                            className="transparent-button"
                            content={
                                props.currentTranslations?.clientButton || 'Client'
                            }
                            onClick={(e) => {
                                e.preventDefault()
                                props.history.push('/login_client')
                            }}
                        >
                            <img
                                src={Imgclientes}
                                alt="Logo"
                                style={{
                                    maxHeight: '30px',
                                    marginBottom: '0.3rem',
                                    filter: 'brightness(0) invert(1)',
                                }}
                            />
                            <Icon
                                name="person"
                                style={{
                                    color: 'gray',
                                    marginBottom: '0.3rem',
                                }}
                            />
                            {props.currentTranslations?.clientButton || 'Client'}
                        </Button>
                    </div>
                </div>
            </Container>

            {/* Right Section */}
            <Container
                style={{
                    flex: isMobile ? 'none' : 0.8,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: isMobile ? 'center' : 'flex-start',
                    padding: isMobile ? '1rem' : '2rem',
                    minHeight: isMobile ? 'auto' : '100vh',
                }}
            >
                <Segment
                    style={{
                        background: 'rgba(255, 255, 255, 0.1)',
                        backdropFilter: 'blur(8px)',
                        padding: isMobile ? '1.5rem' : '2rem',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    {logoImageUrl && (
                        <div
                            style={{
                                textAlign: 'center',
                                marginBottom: '1rem',
                            }}
                        >
                            <img
                                src={logoImageUrl}
                                alt="Logo"
                                style={{
                                    maxWidth: '120px',
                                    filter: 'drop-shadow(1px 1px 2rem white)',
                                }}
                            />
                        </div>
                    )}
                    {/* <Header
                        as="h2"
                        style={{
                        color: 'white',
                        marginBottom: '2rem',
                        textAlign: isMobile ? 'center' : 'left'
                        }}
                    >
                        {props.currentTranslations.loginButton}
                    </Header> */}
                    <Form size="large" onSubmit={handleSubmit}>
                        <Form.Field>
                            <Form.Input
                                fluid
                                type="email"
                                value={username}
                                icon={
                                    <Icon
                                        name="user"
                                        style={{ color: 'gray' }}
                                    />
                                }
                                iconPosition="left"
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={props.currentTranslations.usernameLabel}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Form.Input
                                fluid
                                type="password"
                                value={password}
                                icon={
                                    <Icon
                                        name="lock"
                                        style={{
                                            color: 'gray',
                                            borderColor: 'red',
                                        }}
                                    />
                                }
                                iconPosition="left"
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder={props.currentTranslations.passwordLabel}
                            />
                        </Form.Field>
                        <Button
                            fluid
                            primary
                            type="submit"
                            style={{
                                marginBottom: '1rem',
                                fontSize: isMobile ? '1.2rem' : '1.2rem',
                            }}
                        >
                            {props.currentTranslations.loginButton}
                        </Button>
                        <Container textAlign="center">
                            <label
                                style={{
                                    color: 'white',
                                    textDecoration: 'none',
                                    fontSize: isMobile ? '1rem' : '1rem',
                                }}
                                onClick={(e) => {
                                    e.preventDefault()
                                    setOpenModalPassword(true)
                                }}
                            >
                                {props.currentTranslations?.forgotPassword ||
                                    'Forgot your password?'}
                            </label>
                        </Container>
                        <Container
                            textAlign="center"
                            style={{
                                marginTop: '2rem',
                                color: 'white',
                                fontSize: '0.9rem',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            <div
                                onClick={()=>setOpenModal(true)}
                                style={{ color: 'white', marginRight: 2, cursor: 'pointer'}}
                            >
                                <Icon
                                    name="phone"
                                    style={{
                                        position: 'relative',
                                        top: '-3px',
                                    }}
                                />
                                {props.currentTranslations?.support}
                            </div>
                            {'  '} | {'  '}
                            {/* <a href="#" style={{ color: 'white' }}>{props.currentTranslations.privacyPolicy}</a> */}
                            <Dropdown
                                style={{ marginLeft: 2 }}
                                options={[
                                    {
                                        key: 'es',
                                        value: 'es',
                                        text:
                                            props.currentTranslations?.spanish ||
                                            'Español',
                                        flag: 'mx',
                                    },
                                    {
                                        key: 'en',
                                        value: 'en',
                                        text:
                                            props.currentTranslations?.english ||
                                            'English',
                                        flag: 'us',
                                    },
                                    {
                                        key: 'pt',
                                        value: 'pt',
                                        text:
                                            props.currentTranslations?.portuguese ||
                                            'Português',
                                        flag: 'pt',
                                    },
                                    {
                                        key: 'ar',
                                        value: 'ar',
                                        text:
                                            props.currentTranslations?.arabic || 'عرب',
                                        flag: 'uae',
                                    },
                                ]}
                                placeholder="Seleccione un idioma."
                                value={props.lang ?? 'es'}
                                onChange={(e, { value }) => {
                                    const queryString = props.location.search
                                    const index =
                                        queryString.indexOf('lang=') + 5
                                    const textToReplace = queryString.slice(
                                        index,
                                        index + 2
                                    )
                                    props.history.push({
                                        pathname: '/login',
                                        search: queryString
                                            ? queryString.includes('lang')
                                                ? queryString.replace(
                                                      'lang=' + textToReplace,
                                                      'lang=' + value
                                                  )
                                                : `${queryString}&lang=${value}`
                                            : `?lang=${value}`,
                                    })
                                    props.setLanguage(value)
                                }}
                            />

                            <div style={{display: 'flex', flex: 1, justifyContent: 'flex-end', alignItems: 'center'}}>
                                <label style={{ color: 'white', marginRight: 5 }}>
                                    V 0.1.58
                                </label>
                                <Button
                                    circular
                                    icon
                                    className="transparent-button"
                                    onClick={() => setOpenModal(true)}
                                >
                                    <Icon name="question" />
                                </Button>
                            </div>
                        </Container>
                        <Container
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <img 
                                src={appstoreImg} 
                                style={{
                                    maxWidth: '90px',
                                    filter: 'drop-shadow(1px 1px 2rem white)',
                                    cursor: 'pointer',
                                }}
                                onClick={()=>window.location.href = 'https://apps.apple.com/mx/app/restec-descubre-y-saborea/id6463335518'}
                            />
                            <img 
                                src={playstoreImg} 
                                style={{
                                    maxWidth: '90px',
                                    filter: 'drop-shadow(1px 1px 2rem white)',
                                    cursor: 'pointer',
                                }}
                                onClick={()=>window.location.href = 'https://play.google.com/store/apps/details?id=mx.restec&pcampaignid=web_share'}
                            />  
                        </Container>
                    </Form>
                </Segment>
            </Container>
            
            <Modal
				closeIcon
				basic
				centered={true}
				onClose={() => setOpenModal(false)}
				onOpen={() => setOpenModal(true)}
				open={openModal}
				size='large'
			>
				<Modal.Content content>
					<Segment inverted style={{ height: '100%' }}>
						<Grid stackable divided inverted>
							<Grid.Row columns={2}>
								<Grid.Column
									width={6}
									verticalAlign='middle'
									textAlign='center'
								>
									<Header inverted content='© Ruf 2025' />
								</Grid.Column>
								{/*<Grid.Column width={6}>
									<Header inverted content="Información Desarrolladores" />
									<Divider></Divider>
									<List divided>
										<List.Item
											icon="github"
											content="Adán Contreras"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/Acaryes', '_blank')
											}}
										/>
										<List.Item
											icon="github"
											content="Samuel Gutierrez"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/SamuelCosmo', '_blank')
											}}
										/>
										<List.Item
											icon="github"
											content="German Mariles"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/MarilesBeard5', '_blank')
											}}
										/>
										<List.Item
											icon="github"
											content="Julio Ojeda"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/Jucesr', '_blank')
											}}
										/>
										<List.Item
											icon="github"
											content="Javier Rangel"
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open('https://github.com/xavyrangel', '_blank')
											}}
										/>
									</List>
                              </Grid.Column>*/}
								<Grid.Column width={8}>
									<Header inverted content='Contacto' />
									<Divider></Divider>
									<Header
										size='small'
										inverted
										content='¿Necesitas registrar un nuevo ticket o solicitud?'
									/>
									<List divided inverted>
										{/* <List.Item
											header='Ingresa al Portal: '
											content='https://geologistic.com.mx/Soporte/'
											style={{ cursor: 'pointer' }}
											onClick={() => {
												window.open(
													'https://geologistic.com.mx/Soporte/',
													'_blank'
												)
											}}
										/> */}
										<List.Item
											header='Soporte'
											content='(686) 214 5447, (686) 385 6938,  (686) 510 9915'
										/>
										<List.Item header='Oficina' content='(686) 372 9877' />
										<List.Item
											header='Emergencias'
											content='(686) 420 3333, (686) 214 5447, (686) 385 6938, (686) 510 9915,  (686) 123 6454'
										/>
										<List.Item
											header='Administración'
											content='(686) 122 0316'
										/>
										<List.Item
											header='Ventas'
											content='(686) 510 9915, (686) 196 4736, (686) 420 8586,  (686) 191 1571'
										/>
									</List>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Segment>
				</Modal.Content>
			</Modal>
        </div>
    )
}

const mapStateToProps = (state) => ({
    lang: state.app?.lang,
    currentTranslations: translations[state.app.lang],
})

const mapDispatchToProps = (dispatch) => ({
    login: (params) => dispatch(login(params)),
    validateLogoToken: (logoToken) => dispatch(validateLogoToken(logoToken)),
    setLanguage: (lang) => dispatch(setLanguage(lang)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginRoute)
